import { IMAGES } from "./images";

export const DEFAULT_CONFIG = {
  brand: {
    name: "CARZA",
    tagline: "Drive Cleaner. Live Better.",
    brand_tagline: "Cleaner Cars. Brighter Tomorrow.",
    email: "care@carza.co.in",
    phone: "+91 70116 63967",
    whatsapp: "917011663967",
    location: "Delhi NCR, India",
  },
  cities: [
    { name: "Delhi NCR", live: true },
    { name: "Noida", live: true },
    { name: "Mumbai", live: false },
    { name: "Bengaluru", live: false },
  ],
  vehicles: [
    { name: "Hatchback", multiplier: 1.0 },
    { name: "Sedan", multiplier: 1.1 },
    { name: "SUV", multiplier: 1.3 },
    { name: "Luxury / Premium", multiplier: 1.6 },
  ],
  customer_plans: [
    { id: "daily", name: "One Time", tagline: "Flexible everyday care", price: 349, washes: 1, days: 1, includes: ["1 doorstep wash (~30 min)", "Exterior + interior care", "Tyre & glass finish"], badge: null },
    { id: "15day", name: "15 Days", tagline: "Regular car care", price: 1499, washes: 15, days: 15, includes: ["1 wash daily for 15 days · each wash done in ~30 min", "Exterior + interior care", "Dashboard & tyre detailing"], badge: "POPULAR" },
    { id: "35day", name: "35 Days", tagline: "Best for consistent care", price: 2999, washes: 35, days: 35, includes: ["1 wash daily for 35 days · each wash done in ~30 min", "Full exterior + interior care", "Priority scheduling"], badge: "BEST VALUE" },
  ],
  announcement: "",
  testimonials: [],
  b2b_program: {
    default_service_price: 249,
    note: "Estimated monthly program value is indicative only and finalized in your proposal.",
  },
  traction: {
    washes: 1420, partners: 15, societies: 15, mnc_clients: 35,
    note: "Traction figures represent previously recorded operational activity and may be updated as CARZA scales.",
  },
  unit_economics: {
    avg_realization: 270, chemical_cost: 35, consumables_cost: 25, service_contribution: 70,
    cac: 90, contribution_margin: 140, partner_payout: null, platform_share: null,
    payout_note: "Partner payout and platform share will be displayed once the final payout structure is confirmed.",
    assumption_note: "Figures marked with * are Operating Model assumptions, not audited figures.",
  },
  revenue_projection: {
    title: "Internal Revenue Projection",
    disclaimer: "Forward-looking projections are management estimates and are subject to execution, market conditions and operating performance.",
    points: [
      { label: "Current", value_cr: 0.38 },
      { label: "Year 1", value_cr: 6.6 },
      { label: "Year 2", value_cr: 18 },
      { label: "Year 3", value_cr: 38 },
      { label: "Year 4", value_cr: 81 },
      { label: "Year 5", value_cr: 150 },
    ],
  },
  expansion: {
    live_markets: ["Delhi NCR", "Noida"],
    target_markets: ["Mumbai", "Bengaluru"],
    future_markets: ["UAE", "Singapore", "Malaysia"],
    pathway: ["City", "Partner Network", "Societies", "B2B", "Fleet", "Marketplace"],
  },
  team: [
    { name: "", role: "Founder & CEO", bio: "" },
    { name: "", role: "Operations Lead", bio: "" },
    { name: "", role: "Technology Lead", bio: "" },
  ],
  faqs: [
    { q: "What is CARZA?", a: "CARZA is a technology-enabled car-care company. We combine standardized cleaning processes, trained service partners and a digital platform to deliver convenient, reliable and water-efficient vehicle care at your doorstep." },
    { q: "How does doorstep car cleaning work?", a: "You book online, choose a time slot and location, and a trained CARZA service partner arrives with the required equipment and performs the service using CARZA's standardized process. You inspect the vehicle before we mark the service complete." },
    { q: "How much water does CARZA use?", a: "CARZA uses a controlled low-water / waterless cleaning process designed to eliminate conventional rinse-heavy washing. Instead of a running hose, our process uses a measured cleaning solution applied panel-by-panel with microfiber. We will publish verified per-wash water usage once internal testing is complete." },
    { q: "Is CARZA suitable for all vehicles?", a: "CARZA services hatchbacks, sedans, SUVs and luxury or premium vehicles. The process is paint-safe and adapted to each vehicle type." },
    { q: "How long does a service take?", a: "Most exterior services are completed within the selected slot. Exact duration depends on the service selected and vehicle condition, which your partner confirms on arrival." },
    { q: "Do you offer subscriptions?", a: "Yes. CARZA offers the One Time, 15 Days and 35 Days plans for customers who want regular cleaning at a predictable schedule." },
    { q: "Do you service residential societies?", a: "Yes. We run recurring car-care programs for apartment complexes and residential communities, with on-site service days for residents." },
    { q: "Do you work with dealerships?", a: "Yes. CARZA provides pre-delivery and inventory cleaning programs for automobile dealerships and showrooms, along with corporate and fleet contracts." },
    { q: "How can I become a CARZA partner?", a: "Apply through the Partners page. Partners are onboarded, trained on CARZA SOPs and equipped to deliver the standardized service. Your earning potential depends on bookings, service volume, working hours and location." },
    { q: "How can a business request a B2B proposal?", a: "Fill the B2B proposal form on the For Business page or write to us. Our team will understand your vehicle volume, locations and schedule, and share a tailored proposal." },
  ],
};

export const TIME_SLOTS = ["09:00 AM - 11:00 AM", "11:00 AM - 01:00 PM", "01:00 PM - 03:00 PM", "03:00 PM - 05:00 PM", "05:00 PM - 07:00 PM"];

export const LOCATION_TYPES = ["Home", "Office", "Society", "Other"];

export const B2B_TYPES = [
  "Automobile Dealership", "EV Manufacturer", "Used-Car Dealership", "Corporate Fleet",
  "Rental Company", "Mobility Company", "Residential Society", "Corporate Campus", "Other",
];

export const SERVICE_CARDS = [
  { id: "doorstep", title: "Doorstep Car Cleaning", desc: "Professional exterior and interior care at your location.", image: IMAGES.heroIndia, target: "booking" },
  { id: "subscription", title: "Subscription Plans", desc: "One Time, 15-day and 35-day plans for customers who want regular cleaning.", image: IMAGES.interiorIndia, target: "pricing" },
  { id: "society", title: "Residential Society Services", desc: "Recurring car-care programs for apartment complexes and residential communities.", image: IMAGES.societySrv, target: "business" },
  { id: "corporate", title: "Corporate / MNC Car Care", desc: "Convenient vehicle-care solutions for corporate employees and company vehicles.", image: IMAGES.b2bIndia, target: "business" },
  { id: "dealership", title: "Dealership & Showroom Services", desc: "Pre-delivery and inventory cleaning for automobile dealerships and showrooms.", image: IMAGES.showroomSrv, target: "business" },
  { id: "fleet", title: "Fleet Care", desc: "Recurring cleaning solutions for fleet operators and mobility businesses.", image: IMAGES.fleetSrv, target: "business" },
];

export const WHY_CARE = [
  { icon: "wind", title: "Dust & Pollution", desc: "Daily dust and pollution can affect your vehicle's finish." },
  { icon: "sofa", title: "Dirty Interiors", desc: "Regular use makes interiors accumulate dust, dirt and odour." },
  { icon: "repeat", title: "Neglected Cleaning", desc: "Irregular cleaning can make every cleaning session harder." },
  { icon: "gem", title: "Vehicle Value", desc: "Consistent care helps maintain your vehicle's appearance." },
];

export const WHY_CARZA = [
  { icon: "droplets", title: "Water-Efficient", desc: "Smarter cleaning with a controlled low-water process." },
  { icon: "mapPin", title: "Doorstep Service", desc: "We come to your home, office or society." },
  { icon: "shield", title: "Trained Partners", desc: "Professionals trained to follow CARZA service standards." },
  { icon: "badge", title: "Consistent Experience", desc: "Standardized process instead of unpredictable local car washing." },
  { icon: "smartphone", title: "Easy Booking", desc: "Book, track and manage your car care digitally." },
];

export const COMPARISON = {
  traditional: [
    "Customer travels or waits at the wash location",
    "Service quality changes from wash to wash",
    "Difficult scheduling — whenever they can fit you in",
    "Conventional water-heavy workflow",
    "No standardized digital experience",
  ],
  carza: [
    "Doorstep service — at home, office or society",
    "Trained partners on standardized SOPs",
    "Scheduled service on your date and time slot",
    "Water-efficient, controlled cleaning process",
    "Digital booking and service tracking",
  ],
};

export const WHY_NOW = [
  { title: "Urban vehicle ownership", desc: "More households in Indian metros own cars than ever, and ownership keeps rising." },
  { title: "Convenience-first consumers", desc: "Customers increasingly expect services to come to them - groceries, food, fuel and now car care." },
  { title: "Subscription behavior", desc: "Recurring service subscriptions are a normal buying pattern across urban India." },
  { title: "EVs and new-age dealerships", desc: "EV growth and modern dealership formats demand cleaner, more frequent presentation standards." },
  { title: "Resource-efficient operations", desc: "Businesses and communities are actively looking for lower-water, lower-waste operating choices." },
  { title: "A fragmented market", desc: "Car care remains local, unstandardized and quality-inconsistent - with no dominant organized player." },
];

export const PILLARS = [
  { no: "01", title: "Large & Fragmented Market", desc: "Vehicle care is a recurring, need-based spend across millions of urban vehicles, served today by an unstandardized local supply." },
  { no: "02", title: "Asset-Light Partner Network", desc: "CARZA scales through trained, verified service partners rather than owning fleets of vans or washing infrastructure." },
  { no: "03", title: "Recurring Customer Relationships", desc: "Subscriptions, societies and B2B contracts convert one-time washes into repeatable, scheduled revenue." },
  { no: "04", title: "Technology + Standardized Operations", desc: "Digital booking, service tracking and SOPs make quality repeatable and the network manageable as it scales." },
];

export const B2B_SEGMENTS = [
  { icon: "car", title: "Automobile Dealerships", desc: "Pre-delivery cleaning and inventory care." },
  { icon: "zap", title: "EV Manufacturers", desc: "Consistent vehicle preparation before customer delivery." },
  { icon: "warehouse", title: "Used-Car Showrooms", desc: "Keep inventory presentation-ready." },
  { icon: "briefcase", title: "Corporate Fleets", desc: "Recurring vehicle-care programs." },
  { icon: "bus", title: "Rental & Mobility Companies", desc: "Scheduled cleaning for high-turnover vehicles." },
  { icon: "home", title: "Residential Societies", desc: "Scheduled doorstep car care for residents." },
  { icon: "building", title: "Corporate Campuses", desc: "On-site car care for employees and company vehicles." },
];

export const B2B_SERVICES = [
  { title: "Recurring Vehicle Cleaning", what: "Scheduled cleaning cycles for your vehicles — daily, weekly or custom.", who: "Fleets, corporates, rental companies", benefit: "A consistently presentable fleet without managing vendors." },
  { title: "Pre-Delivery Cleaning", what: "New-vehicle preparation to handover standard before customer delivery.", who: "Dealerships, EV manufacturers", benefit: "Every customer receives a spotless first impression." },
  { title: "Fleet Cleaning Programs", what: "Program-based cleaning for large vehicle groups across locations.", who: "Fleet operators, mobility companies", benefit: "Standardized care at scale with central visibility." },
  { title: "Showroom & Inventory Care", what: "Ongoing presentation cleaning for display and stock vehicles.", who: "Showrooms, used-car dealers", benefit: "Inventory always looks sale-ready." },
  { title: "Residential Society Programs", what: "Scheduled on-site car-care days for residents.", who: "Societies, apartment complexes", benefit: "A valued amenity with zero management overhead." },
  { title: "Corporate Employee Car Care", what: "Doorstep care for employee vehicles on campus.", who: "Corporate campuses, MNCs", benefit: "A premium employee benefit, effortlessly managed." },
];

export const B2B_COMPARISON = [
  { factor: "Travel / Vehicle Movement", traditional: "Vehicles may need to be moved or coordinated manually.", carza: "Doorstep/on-site service can reduce unnecessary vehicle movement." },
  { factor: "Staff Coordination", traditional: "Coordinating individual washers or vendors takes time.", carza: "One accountable partner network managed by CARZA." },
  { factor: "Scheduling", traditional: "Fixed, infrequent and hard to align with operations.", carza: "Flexible recurring schedules built around your operations." },
  { factor: "Service Consistency", traditional: "Service quality may vary across individual providers.", carza: "Standardized SOPs support consistent service delivery." },
  { factor: "Water Usage", traditional: "Conventional washes are water-heavy.", carza: "A controlled low-water / waterless process by design." },
  { factor: "Operational Visibility", traditional: "Little record of what was serviced, when.", carza: "Digitally tracked services with centralized reporting." },
  { factor: "Recurring Service", traditional: "Ad-hoc arrangements need constant follow-up.", carza: "Contract-based recurring programs." },
  { factor: "Quality Control", traditional: "No standardized checks.", carza: "Trained partners with CARZA quality checks." },
  { factor: "Management Time", traditional: "Multiple touchpoints to manage.", carza: "One point of contact and a dedicated program manager." },
];

export const PARTNER_VALUES = [
  { icon: "calendar", title: "More Bookings", desc: "Get access to customer demand." },
  { icon: "route", title: "Less Travel", desc: "Focus on nearby service opportunities." },
  { icon: "graduation", title: "Training & Support", desc: "Learn CARZA's standardized service process." },
  { icon: "smartphone", title: "Digital Management", desc: "Manage bookings and earnings digitally." },
  { icon: "clock", title: "Flexible Work", desc: "Choose your working availability." },
  { icon: "star", title: "Professional Brand", desc: "Build your service career with CARZA." },
];

export const PARTNER_STEPS = [
  { no: "01", title: "Register", desc: "Share your basic details in under 2 minutes." },
  { no: "02", title: "Verification", desc: "Quick verification of your mobile number and background." },
  { no: "03", title: "Training", desc: "Learn CARZA's standardized service process and SOPs." },
  { no: "04", title: "Start Accepting Bookings", desc: "Receive nearby bookings and manage everything digitally." },
];

export const PARTNER_URGENCY = [
  "Don't spend your day searching for customers.",
  "Don't waste time travelling long distances for individual jobs.",
  "Build a recurring customer base through CARZA.",
  "Get access to a growing network of vehicle owners.",
];

export const PARTNER_EARNING_NOTE = "Your earning potential depends on bookings, service volume, working hours and location.";

export function nextDays(n) {
  const out = [];
  const d = new Date();
  for (let i = 0; i < n; i++) {
    const x = new Date(d);
    x.setDate(d.getDate() + i);
    out.push(x.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" }));
  }
  return out;
}

// ---- Aggregator (centre slot-booking — pay the centre directly) ----
export const AGG_STATUSES = [
  "Booking Requested", "Booking Confirmed", "Reschedule Requested", "Service In Progress",
  "Service Completed", "Cancelled by Customer", "Cancelled by Centre", "No-Show",
];
export const AGG_ACTIVE_STATUSES = ["Booking Requested", "Booking Confirmed", "Reschedule Requested", "Service In Progress"];
export const CANCELLATION_REASONS = [
  "Change of plans", "Incorrect booking details", "Slot no longer convenient",
  "Found another service provider", "Other",
];
export const CANCELLATION_POLICY = [
  "More than 2 hours before your slot — free cancellation.",
  "Within 2 hours of your slot — cancellation is allowed and recorded as a late cancellation.",
  "After the service has started — cancellation is closed. Please contact CARZA support.",
  "A no-show is recorded only after the centre confirms the vehicle was not made available.",
  "No cancellation fees or penalties apply at this time.",
];
